import React from 'react';
import classes from '../main.module.css'

const Contact = ({ onContactClick }) => {

    const contentText = "Crafting a contact text for a digital agency involves providing essential information for potential clients or collaborators to reach out."
    const whatsappUrl = "https://wa.me/918870343924"
    const instagramUrl = "https://www.instagram.com/her__devil__cat?igsh=MWdzeGR0ZzJqY29qbg%3D%3D"
    const xUrl = "https://twitter.com/RohitSiva8?t=njcRUvBfFtxFCcWT7E229g&s=09"
    const linkedinUrl = "https://www.linkedin.com/in/siva-8bb758230?utm_source=share_via&utm_content=profile&utm_medium=member_ios"

    return (
        <section id="contact" className={classes.Contact}>
            <div className={classes.ContactHeader}>
                <div className={classes.ContactTitleRow}>
                    <h1>Let's Talk</h1>
                    <div className={classes.ContactButton} onClick={onContactClick}>
                        <img src={`/images/ic_arrow_up.svg`} alt="arrow" />
                        <pre>Contact</pre>
                        <pre>Now</pre>
                    </div>
                </div>
                <p className={classes.ContactDescription}>{contentText}</p>
            </div>
            <div className={classes.SocialConnect}>
                <span className="connect-text">Connect Us</span>
                <img src={`/images/about_arrow.svg`} alt="arrow" />
                <div className={classes.ContactSocialIcons}>
                    <a href={whatsappUrl} target='_blank' rel='noopener noreferrer'><img src={`/images/ic_whatsapp.svg`} alt="whatsapp" /></a>
                    <a href={xUrl} target='_blank' rel='noopener noreferrer'><img src={`/images/ic_x.svg`} alt="x" /></a>
                    <a href={linkedinUrl} target='_blank' rel='noopener noreferrer'><img src={`/images/ic_linkedin.svg`} alt="linkdin" /></a>
                    <a href={instagramUrl} target='_blank' rel='noopener noreferrer'><img src={`/images/ic_instagram.svg`} alt="insta" /></a>
                </div>
            </div>
        </section>
    )

}

export default Contact